<div class="dialog">
    <div class="dialog-header">
        <h2>{{ 'technicals.tokens.dialog.success.title' | translate }}</h2>
        <a class="dialog-close" (click)="onClose()">&times;</a>
    </div>
    <div class="dialog-body">
        <div class="alert alert-warning">
            <i class="i i-warning"></i>
            <strong>{{ 'technicals.tokens.dialog.success.warning-title' | translate }}</strong>
            {{ 'technicals.tokens.dialog.success.warning-text-token' | translate }}<br>
            {{ 'technicals.tokens.dialog.success.warning-text-copy' | translate }}

        </div>

        <div class="form-row">
            <label>{{ 'shared.table.label' | translate }}</label>
            <input type="text" readonly [value]="token.label || '—'" class="readonly-field">
        </div>

        <div class="form-row">
            <label>{{ 'shared.table.scopes' | translate }}</label>
            <input type="text" readonly [value]="token.scopes?.join(', ') || '—'" class="readonly-field">
        </div>

        <div class="form-row">
            <label>{{ 'shared.table.client-id' | translate }}</label>
            <div class="input-copy-row">
                <input type="text" readonly [value]="token.client_id" class="readonly-field" spellcheck="false" onclick="this.select()">
                <a class="button button-basic-primary button-icon" (click)="onCopyClientId()">
                    <i class="i i-duplicate"></i>
                </a>
            </div>
        </div>

        <div class="form-row">
            <label>{{ 'technicals.tokens.dialog.success.client-secret' | translate }}</label>
            <div class="input-copy-row">
                <input
                    type="text"
                    readonly
                    [value]="token.client_secret"
                    class="token-field"
                    spellcheck="false"
                    onclick="this.select()">
                <a class="button button-basic-primary button-icon" (click)="onCopySecret()">
                    <i class="i i-duplicate"></i>
                </a>
            </div>
        </div>

        <div class="buttons buttons-flex">
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>
